/**
 * TEMPORARY, for #114 (seek accuracy on Samsung/Tizen). Remove once #114 is decided.
 *
 * With ?debug=seek in the player URL, every seek on a video element is shown in the
 * bottom-left corner: the target, where currentTime says it landed, the difference and
 * how long the seek took. TVs have no console without developer mode, so the lines are
 * on screen to be filmed next to the diagnostic clip's frame numbers. Some browsers report
 * the requested time even when they show the nearest keyframe, so compare "landed" with
 * the frame number in the same shot. Without the flag this does nothing.
 *
 * Flags can be combined: ?debug=seek,queue (queue: see queue-debug.ts).
 */
const MAX_LINES = 10;
let flags;
let panel;
const lines = [];
/** True when the player URL has ?debug=<name> (comma-separated list). */
export function debugFlagEnabled(name) {
    if (!flags) {
        flags = new Set();
        try {
            const match = typeof location !== 'undefined' ? /(?:^|[?&])debug=([^&#]*)/.exec(location.search) : null;
            if (match && match[1]) {
                for (const flag of decodeURIComponent(match[1]).split(',')) {
                    if (flag.trim())
                        flags.add(flag.trim());
                }
            }
        }
        catch (_error) {
            // No flags.
        }
    }
    return flags.has(name);
}
/** Adds a line to the on-screen debug overlay (last 10 lines) and the console. */
export function showDebugLine(line) {
    lines.unshift(line);
    if (lines.length > MAX_LINES)
        lines.length = MAX_LINES;
    if (typeof console !== 'undefined')
        console.log(`[debug] ${line}`);
    if (typeof document === 'undefined' || !document.body)
        return;
    if (!panel) {
        panel = document.createElement('div');
        panel.setAttribute('data-debug', 'overlay');
        const s = panel.style;
        s.position = 'fixed';
        s.left = '8px';
        s.bottom = '8px';
        s.zIndex = '2147483647';
        s.background = 'rgba(0, 0, 0, 0.75)';
        s.color = '#00ff66';
        s.font = '20px/1.3 monospace';
        s.padding = '8px 12px';
        s.whiteSpace = 'pre';
        s.pointerEvents = 'none';
        document.body.appendChild(panel);
    }
    panel.textContent = lines.join('\n');
}
/** Logs every seek on this element when ?debug=seek is set. */
export function watchSeeksForDebug(video) {
    if (!debugFlagEnabled('seek'))
        return;
    let target = 0;
    let startedAt = 0;
    video.addEventListener('seeking', () => {
        target = video.currentTime;
        startedAt = Date.now();
    });
    video.addEventListener('seeked', () => {
        const landed = video.currentTime;
        const diffMs = Math.round((landed - target) * 1000);
        const clock = new Date().toISOString().slice(11, 23);
        showDebugLine(`${clock} seek target ${target.toFixed(3)} -> landed ${landed.toFixed(3)} ` +
            `(${diffMs >= 0 ? '+' : ''}${diffMs} ms) in ${Date.now() - startedAt} ms`);
    });
}
//# sourceMappingURL=seek-debug.js.map